import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchIntegrationJobs } from '#/modules/orgDashboard/api/integration/orgDashboardApiFetchIntegrationJobs';
import { isOrgDashboardApiIntegrationTypes } from '#/modules/orgDashboard/api/integration/types/OrgDashboardApiIntegrationType';
import { orgDashboardApiIsomorphicFetchOrg } from '#/modules/orgDashboard/api/orgDashboardApiFetchOrg';
import { OrgDashboardViewIntegrationPageLoadable } from '#/modules/orgDashboard/pages/integrations/view/OrgDashboardViewIntegrationPageLoadable';
import {
  orgDashboardListIntegrationsRoute,
  orgDashboardViewIntegrationRoute,
} from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { OrgDashboardListIntegrationPageLoadable } from '../list/OrgDashboardListIntegrationPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, type },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardViewIntegrationRoute>) {
  if (!isOrgDashboardApiIntegrationTypes(type)) {
    return idealistRedirect({ request, context })(
      orgDashboardListIntegrationsRoute.with({ orgId }),
    );
  }

  const [{ org }, integrationJobs] = await Promise.all([
    orgDashboardApiIsomorphicFetchOrg({ request, context })(orgId),
    orgDashboardApiIsomorphicFetchIntegrationJobs({ request, context })(
      orgId,
      type,
    ),
    OrgDashboardListIntegrationPageLoadable.load(),
  ]);

  if (!org[type]) {
    return idealistRedirect({ request, context })(
      orgDashboardListIntegrationsRoute.with({ orgId }),
    );
  }

  return { type, integrationJobs };
}

export default function OrgDashboardViewIntegrationHorizonRoute({
  loaderData: { type, integrationJobs },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <OrgDashboardViewIntegrationPageLoadable
      type={type}
      integrationJobs={integrationJobs}
    />
  );
}
